import { render, staticRenderFns } from "./BondedRegionDialog.vue?vue&type=template&id=70574b58&scoped=true"
import script from "./BondedRegionDialog.vue?vue&type=script&lang=js"
export * from "./BondedRegionDialog.vue?vue&type=script&lang=js"
import style0 from "./BondedRegionDialog.vue?vue&type=style&index=0&id=70574b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70574b58",
  null
  
)

export default component.exports